import { render, staticRenderFns } from "./Once.vue?vue&type=template&id=b8bcaa2c"
import script from "./Once.vue?vue&type=script&lang=js"
export * from "./Once.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports